module.exports = __webpack_public_path__ + "static/media/map_bg.74b0250c.jpg";